import React from "react";
import "./BottomBar.css"; // Import the CSS file for styling
import { Link } from "react-router-dom";

const BottomBar = () => {
  return (
    <footer className="bottom-bar">
      <div className="link-uri-utile">
        <h4 className="underlined">LINKURI UTILE</h4>
        <div className="image-links">
          <a
            href="https://anpc.ro/ce-este-sal/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/imagini-bottom-bar/SAL.png" alt="Ce este SAL | ANPC" />
          </a>
          <a
            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/imagini-bottom-bar/SOL.png"
              alt="Online Dispute Resolution"
            />
          </a>
        </div>
        <a
          className="anpc-link"
          href="https://anpc.ro"
          target="_blank"
          rel="noopener noreferrer"
        >
          ANPC
        </a>
        <div></div>
        <Link
          className="anpc-link"
          to="/policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Termeni și condiții
        </Link>
      </div>
      <div className="white-line"></div>
      <img src="/logo-inverted.png" alt="Logo" className="footer-logo" />
      <div className="white-line"></div>
      <div className="contact-info">
        <h4 className="underlined">CONTACT</h4>
        <p className="text-right">
          FIRU' ARTEI S.R.L.
          <br />
          CUI: 50536359 J2024021627000
          <br />
          Telefon: (+40) 742 634 112
          <br />
          E-mail:{" "}
          <a href="mailto:contact.firuartei@gmail.com">
            contact.firuartei@gmail.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default BottomBar;
